import { identity } from 'ramda'

export const available = identity
